export default {
  contact_support: "contact {support}",
  here: "here",
  text1: "Something went wrong when attempting to authenticate with the server!",
  text2: "We have already been notified of this problem.",
  text3: "You can check your systems availability ",
  text4: "If you can provide further information, please ",
  text5: "YOU WOULD NEED TO MANUALLY SIGN OUT AND LOG BACK IN.",
  title: "Authentication error",
  quote:
    "I don’t know who you are, I don’t know what you want, but I will find you... and get you logged in.",
}
